import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonHeader,
  IonButton,
  IonFooter,
} from "@ionic/react";
import React from "react";
import { useHistory } from "react-router-dom";
function EndSession() {
  let history = useHistory();
  return (
    <>
      <IonPage placeholder={undefined}>
        <IonHeader className="ion-no-border" placeholder={undefined}>
          <IonGrid
            className="container create-patient-pages"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="top-inner-sec">
                  <div className="left-arrow">
                    <svg
                      onClick={() => {
                        history.goBack();
                      }}
                      className="svg-icons"
                      width="16"
                      height="26"
                      viewBox="0 0 16 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                        fill="#31344E"
                        stroke="black"
                      />
                    </svg>
                  </div>
                  <h1>James Baker</h1>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonHeader>
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="visit-summary-inner-sec end-session-summary">
                  <h3> Visit Summary Note</h3>
                  <h4>Friday - Feb 4, 2022</h4>
                  <div className="visit-summary-inner-detail">
                    <p>
                      Visit summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.Visit summary info will go
                      here.Visit summary info will go here.Visit summary info
                      will go here.Visit summary info will go here.Visit summary
                      info will go here.Visit summary info will go here.Visit
                      summary info will go here.
                    </p>
                  </div>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        <IonFooter
          className="ion-no-border end-session-footer"
          placeholder={undefined}
        >
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <IonButton
                  className="generic-btn green-btn"
                  type="submit"
                  placeholder={undefined}
                >
                  Submit and End Session
                </IonButton>
                <IonButton className="generic-btn" placeholder={undefined}>
                  Continue Session
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonFooter>
      </IonPage>
    </>
  );
}
export default EndSession;
